<template>
  <v-snackbar              
    :color="color"
    :top="top"
    :right="right"
    v-model="snackbar"
    dark
    multi-line
    absolute
    :timeout="timeout"
  >
    <div :style="`color:${colorFI};`">
      {{this.mensagem}}
    </div>
    <v-icon
      :color="colorFI"
      size="16"
      @click="snackbar = false"
    >close
    </v-icon>        
  </v-snackbar>       
</template>

<script>
  export default {
    data () {
      return {
        color: '',
        mensagem: '',
        top: true,
        right: false,
        snackbar: false,
        colorFI: '',
        timeout: 5000
      }
    },

    methods: {
      snack(cor, msg, cfi) {
        this.top = true
        this.right = true
        this.color = cor
        this.colorFI = cfi
        this.mensagem = msg
        this.snackbar = true
      }
    }
  }
</script>

<style>

</style>
